import React from "react";
import { Instagram, Linkedin, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/to01yomw_Sin%20ti%CC%81tulo-1%20copia.png";

export default function Footer() {
  return (
    <footer className="relative bg-[#0A1628] pt-20 md:pt-28 pb-8 overflow-hidden text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 mb-10">
          <div className="lg:col-span-5">
            <img src={LOGO_URL} alt="Global Nutralabs" className="h-16 w-auto" />
            <p className="mt-6 text-slate-400 max-w-md leading-relaxed">Fabricante español de complementos alimenticios y nutrición deportiva. Marca blanca, fabricación propia y para terceros (B2B) con departamento I+D. Desde Arganda del Rey (Madrid) para todo el mundo.</p>
            <div className="mt-6 flex gap-3">
              <SocialBtn href="#" icon={<Instagram className="w-4 h-4" />} label="Instagram" />
              <SocialBtn href="#" icon={<Linkedin className="w-4 h-4" />} label="LinkedIn" />
              <SocialBtn href="mailto:sales@globalnutralabs.com" icon={<Mail className="w-4 h-4" />} label="Email" />
            </div>
          </div>

          <FooterCol title="Empresa" links={[
            { label: "Nosotros", href: "#nosotros" },
            { label: "Servicios", href: "#servicios" },
            { label: "Productos", href: "#productos" },
            { label: "Proceso", href: "#proceso" },
            { label: "I+D", href: "#idi" },
            { label: "Capacidad", href: "#capacidad" },
          ]} />
          <FooterCol title="Calidad" links={[
            { label: "Certificado GMP", href: "#calidad" },
            { label: "Registro FDA", href: "#calidad" },
            { label: "Internacional", href: "#internacional" },
            { label: "Apoyo regulatorio", href: "#internacional" },
          ]} />
          <FooterCol title="Contacto" links={[
            { label: "sales@globalnutralabs.com", href: "mailto:sales@globalnutralabs.com" },
            { label: "+34 918 834 453", href: "tel:+34918834453" },
            { label: "Arganda del Rey, Madrid", href: "#contacto" },
          ]} />
        </div>

        <div className="mt-8 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Global Nutralabs®. Todos los derechos reservados.</p>
          <div className="flex gap-6 text-xs text-slate-500">
            <a href="#" data-testid="footer-privacy" className="hover:text-white transition-colors">Política de privacidad</a>
            <a href="#" data-testid="footer-legal" className="hover:text-white transition-colors">Aviso legal</a>
            <a href="#" data-testid="footer-cookies" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function SocialBtn({ href, icon, label }) {
  return (
    <a href={href} aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`} className="w-10 h-10 rounded-sm border border-white/15 flex items-center justify-center text-slate-400 hover:text-white hover:border-[#0A84E2] hover:bg-[#0A84E2]/10 transition-all">{icon}</a>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="lg:col-span-2">
      <h4 className="font-display text-xs uppercase tracking-[0.25em] text-white mb-5 font-semibold">{title}</h4>
      <ul className="space-y-3">
        {links.map((l) => (<li key={l.label}><a href={l.href} className="text-sm text-slate-400 hover:text-white transition-colors">{l.label}</a></li>))}
      </ul>
    </div>
  );
}
